import React, { Fragment, useEffect, useRef, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal, Dropdown } from 'react-bootstrap'
import DatePicker from "react-datepicker"
import Select from 'react-select'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import DeleteModal from 'pages/parts/DeleteModal'
import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import Rightbar from 'pages/main/cheques/Rightbar'
import Cheque from "../../../components/Cheque"

import { httpOk, GET, DELETE, PUT, POST } from 'helpers/api'
import { formatDate, formatMoney, findKeyFromArrayByValue, regexPhoneNumber, checkPermission } from 'helpers/helpers'
import { Link, useLocation, useNavigate } from "react-router-dom"
import { useReactToPrint } from "react-to-print"

import { ProductType1, ProductType3, ProductType4, ProductType5 } from 'pages/workshop/cheques/product_types'
import useDidMountEffect from "pages/parts/useDidMountEffect"
import CustomTooltip from "pages/parts/CustomTooltip"
import { SET_CASHBOX } from "store/cashbox/actions"
import { useDispatch, useSelector } from "react-redux"
import ReturnModal from "./Return"

function Index() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();
	const date = new Date()

	const printChequeRef = useRef(null);
	// const isInitialLoad = useRef(true);

	const handlePrint = useReactToPrint({
		content: () => printChequeRef.current,
	});

	const productImages = [
		{
			id: 1,
			// image: <ProductType1 />,
		},
		{
			id: 3,
			image: <ProductType3 />,
		},
		{
			id: 4,
			image: <ProductType4 />,
		},
		{
			id: 5,
			image: <ProductType5 />,
		},
	]

	const statuses = [
		{ 'id': 1, 'name': t('open') },
		{ 'id': 10, 'name': t('closed') },
		{ 'id': -1, 'name': t('deleted') },
	]

	const chequeTypes = [
		{ 'id': 'loyalty', 'name': t('loyalty') },
		{ 'id': 'debt', 'name': t('debt') },
		{ 'id': 'discount', 'name': t('discount') },
		{ 'id': 'bool_no_profit', 'name': t('no_profit') },
		{ 'id': 'bool_no_service_percentage', 'name': t('no_service_percentage') },
		{ 'id': 'organizations', 'name': t('organization') },
	]

	const chequeDates = [
		{ 'id': 'today', 'name': t('today') },
		{ 'id': 'currentWeek', 'name': t('current_week') },
		{ 'id': 'currentMonth', 'name': t('current_month') },
		{ 'id': 'currentYear', 'name': t('current_year') },
		{ 'id': 'yesterday', 'name': t('yesterday') },
		{ 'id': 'lastWeek', 'name': t('last_week') },
		{ 'id': 'lastMonth', 'name': t('last_month') },
		{ 'id': 'lastYear', 'name': t('last_year') },
		{ 'id': 'other', 'name': t('other') }, // Для "Другой..."
	];

	const initialFilter = {
		start_date: formatDate(new Date(), 'yyyy-MM-dd'),
		end_date: formatDate(new Date(), 'yyyy-MM-dd'),
		chequeDates: "today",
		random: 0,
		search: '',
	};

	const reduxCashbox = useSelector(state => state.cashbox)

	const [cashiers, setCashiers] = useState([])
	const [chequeStatuses, setChequeStatuses] = useState([])
	const [clients, setClients] = useState([])
	const [printData, setPrintData] = useState({})

	const [modalDelete, setModalDelete] = useState({ show: false })
	const [returnModal, setReturnModal] = useState({ show: false, cheque: {} })
	const [showModal, setShowModal] = useState(false)
	const [showRightBar, setShowRightBar] = useState(false)
	const [selectedItem, setSelectedItem] = useState({})
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(true)

	const [filterData, setFilterData] = useState({ ...initialFilter })
	const [pagination, setPagination] = useState({
		url: '/cheques',
		response: null
	})
	const [data, setData] = useState([])

	async function printCheque(item, a4 = false) {
		const response = await GET(`/cheques/${item.id}`, {}, { loader: true })
		if (httpOk(response)) {
			response.data.a4 = a4;
			setPrintData(response.data);
			setTimeout(() => {
				handlePrint()
			}, 100);
		}
	}

	async function sendTelegramCheque(item, a4 = false) {
		const response = await POST(`/cheques-send-telegram/${item.id}`, { id: item.id }, { loader: true })
		if (httpOk(response)) {
		}
	}

	function toggleModalDelete(bool, item = {}) {
		if (bool) {
			setShowRightBar(false)
		}

		setModalDelete({ show: bool, ...item, note: '' })
	}

	async function deleteItem() {
		const response = await DELETE(`/cheques/${modalDelete.id}`, { note: modalDelete.note }, { loader: true })
		if (httpOk(response)) {
			getData()
			toggleModalDelete(false)
		}
	}

	async function changeChequeStatus(item, status) {
		const response = await PUT(`/cheques-status`, { id: item.id, status: status }, { loader: true })
		if (httpOk(response)) {
			getData()
		}
	}

	function redirect(item, index) {
		if (item.status === 3) {
			toggleRightbar(true, item, index)
			return;
		}
		navigate(`/cashbox/edit/${item.id}`)
	}

	async function toggleRightbar(boolean = false, item, index) {

		var dataCopy = [...data.data]
		for (let i = 0; i < dataCopy.length; i++) {
			dataCopy[i]['showSidebar'] = false
		}
		if (boolean) {
			const response = await GET(`/cheques/${item.id}`, {}, { loader: true })
			if (httpOk(response)) {
				setSelectedItem(response.data)
				setShowRightBar(boolean)
			}

		} else {
			setShowRightBar(boolean)
			setSelectedItem({})
		}
	}

	async function toggleReturnModal(boolean = false, item, index) {
		if (boolean) {
			const response = await GET(`/cheques/${item.id}`, {}, { loader: true })
			if (httpOk(response)) {
				// if (!response?.data?.products?.filter(item => item.product_type === 1 || (item.product_type === 3 && item.is_prepared))?.length) {
				// 	toast.error('Нет продуктов для возврата');
				// 	setShowModal(false)
				// 	return;
				// }

				setReturnModal({ show: boolean, cheque: response.data })
			}

		} else {
			setReturnModal({ show: boolean, cheque: {} })
		}
	}

	function resetFilter() {
		var filterDataCopy = {
			start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
			end_date: formatDate(new Date(), 'yyyy-MM-dd'),
			status: null,
			cashier_login: null,
			search: '',
			random: filterData.random + 1
		}
		setFilterData(filterDataCopy)
	}

	async function checkFilter() {
		let hasFilter = false;
		for (const key in filterData) {
			if (filterData[key] !== initialFilter[key]) {
				hasFilter = true;
				break;
			}
		}
		setFilterDataExist(hasFilter);
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function paginate(page, size) {
		setFilterData({ ...filterData, 'page': page, 'size': size })
	}

	function returnClassStatus(status) {
		if (status === 1) {
			return ""
		}
		if (status === 2) {
			return "bg-warning text-white"
		}
		if (status === 3) {
			return "bg-primary text-white"
		}
	}

	function searchWithFilter() {
		checkFilter();

		const params = new URLSearchParams();
		for (const key in filterData) {
			if (filterData[key] !== null && filterData[key] !== '' && filterData[key] !== initialFilter[key]) {
				params.set(key, filterData[key]);
			}
		}
		const newUrl = `${location.pathname}?${params.toString()}`;
		navigate(newUrl);
		setDropdownIsOpen(false)
	}

	async function getData(params) {
		if (!params) {
			params = filterData;
		}
		const response = await GET("/cheques", params, { loader: true });
		if (httpOk(response)) {
			setData(response.data);
			setPagination({ ...pagination, 'url': location.pathname + location.search, 'response': response.data });
		}
	}

	async function getPaymentTypes() {
		const response = await GET('/helper/payment-types')
		// if (httpOk(response)) setPaymentTypes(response.data)
		if (httpOk(response)) dispatch(SET_CASHBOX({ paymentTypes: response.data }))
	}

	async function getChequeStatuses() {
		const response = await GET('/helper/cheques-statuses')
		response.data.unshift({ id: -1, name: t('deleted') });
		if (httpOk(response)) setChequeStatuses(response.data)
	}

	async function getClients() {
		const response = await GET('/helper/clients')
		if (httpOk(response)) setClients(response.data)
	}

	async function getCashiers() {
		const response = await GET('/helper/cashiers')
		if (httpOk(response)) setCashiers(response.data)
	}

	useEffect(() => {
		getPaymentTypes()
		getChequeStatuses()
		getClients()
		getCashiers()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		const params = new URLSearchParams(location.search);
		const filtersFromUrl = {};
		let hasChangesFromUrl = false;
		params.forEach((value, key) => {
			if (value) {
				filtersFromUrl[key] = value;
				hasChangesFromUrl = true;
			}
		});
		if (hasChangesFromUrl) {
			setFilterData(prev => ({ ...prev, ...filtersFromUrl }));
			getData({ ...initialFilter, ...filtersFromUrl });
		} else {
			// setFilterData(initialFilter);
			getData(initialFilter);
		}
	}, [location.search, navigate]); // eslint-disable-line react-hooks/exhaustive-deps

	useDidMountEffect(() => {
		searchWithFilter()
	}, [filterData.search, filterData.page, filterData.size, filterData.random]) // eslint-disable-line react-hooks/exhaustive-deps

	useDidMountEffect(() => {
		const today = new Date();
		let newStartDate = null;
		let newEndDate = null;

		const getStartOfWeek = (date) => {
			const d = new Date(date);
			const day = d.getDay();
			const diff = d.getDate() - day + (day === 0 ? -6 : 1);
			return new Date(d.setDate(diff));
		};

		const getEndOfWeek = (date) => {
			const d = new Date(date);
			const startOfWeek = getStartOfWeek(d);
			const endOfWeek = new Date(startOfWeek);
			endOfWeek.setDate(startOfWeek.getDate() + 6);
			return endOfWeek;
		};

		switch (filterData.chequeDates) {
			case 'today':
				newStartDate = formatDate(today, 'yyyy-MM-dd');
				newEndDate = formatDate(today, 'yyyy-MM-dd');
				break;
			case 'currentWeek':
				const startOfCurrentWeek = getStartOfWeek(today);
				const endOfCurrentWeek = getEndOfWeek(today);
				newStartDate = formatDate(startOfCurrentWeek, 'yyyy-MM-dd');
				newEndDate = formatDate(endOfCurrentWeek, 'yyyy-MM-dd');
				break;
			case 'currentMonth':
				const startOfCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1);
				const endOfCurrentMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
				newStartDate = formatDate(startOfCurrentMonth, 'yyyy-MM-dd');
				newEndDate = formatDate(endOfCurrentMonth, 'yyyy-MM-dd');
				break;
			case 'currentYear':
				const startOfCurrentYear = new Date(today.getFullYear(), 0, 1);
				const endOfCurrentYear = new Date(today.getFullYear(), 11, 31);
				newStartDate = formatDate(startOfCurrentYear, 'yyyy-MM-dd');
				newEndDate = formatDate(endOfCurrentYear, 'yyyy-MM-dd');
				break;
			case 'yesterday':
				const yesterday = new Date(today);
				yesterday.setDate(today.getDate() - 1);
				newStartDate = formatDate(yesterday, 'yyyy-MM-dd');
				newEndDate = formatDate(yesterday, 'yyyy-MM-dd');
				break;
			case 'lastWeek':
				const lastWeekEnd = new Date(today);
				lastWeekEnd.setDate(today.getDate() - 7);
				const startOfLastWeek = getStartOfWeek(lastWeekEnd);
				const endOfLastWeek = getEndOfWeek(lastWeekEnd);
				newStartDate = formatDate(startOfLastWeek, 'yyyy-MM-dd');
				newEndDate = formatDate(endOfLastWeek, 'yyyy-MM-dd');
				break;
			case 'lastMonth':
				const startOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
				const endOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
				newStartDate = formatDate(startOfLastMonth, 'yyyy-MM-dd');
				newEndDate = formatDate(endOfLastMonth, 'yyyy-MM-dd');
				break;
			case 'lastYear':
				const startOfLastYear = new Date(today.getFullYear() - 1, 0, 1);
				const endOfLastYear = new Date(today.getFullYear() - 1, 11, 31);
				newStartDate = formatDate(startOfLastYear, 'yyyy-MM-dd');
				newEndDate = formatDate(endOfLastYear, 'yyyy-MM-dd');
				break;
			case 'other':
				newStartDate = filterData.start_date;
				newEndDate = filterData.end_date;
				break;
			default:
				newStartDate = null;
				newEndDate = null;
				break;
		}

		if (newStartDate !== filterData.start_date || newEndDate !== filterData.end_date) {
			setFilterData(prevFilterData => ({
				...prevFilterData,
				start_date: newStartDate,
				end_date: newEndDate,
			}));
		}
	}, [filterData.chequeDates]); // eslint-disable-line react-hooks/exhaustive-deps

	function getStatusIcon(status) {
		if (status === 1) {
			return "uil-file-plus-alt"
		} else if (status === 2) {
			return "uil-clock"
		} else if (status === 3) {
			return "uil-check-circle"
		}
	}

	const renderTooltip = (props, item) => (
		<Tooltip id="button-tooltip" {...props}>
			{item.name ?
				<>
					{item.name}:
					{item.total_count}
				</>
				:
				item
			}
		</Tooltip>
	);

	const toNumber = (value) => Number(value || 0)

	function getChequeTotalAmount(item = {}) {
		if (item.net_total_amount !== undefined) return toNumber(item.net_total_amount)

		return toNumber(item.total_amount) - toNumber(item.total_returned_amount)
	}

	function getChequeDebtAmount(item = {}) {
		if (item.net_cheque_debt !== undefined) return toNumber(item.net_cheque_debt)

		const chequeDebt = toNumber(item.cheque_debt) - toNumber(item.debt_returned_amount)
		if (item.cheque_debt !== undefined || item.debt_returned_amount !== undefined) {
			return Math.max(chequeDebt, 0)
		}

		return Math.max(toNumber(item.total_amount) - toNumber(item.paid), 0)
	}

	function getChequePaidAmount(item = {}) {
		return Math.max(getChequeTotalAmount(item) - getChequeDebtAmount(item), 0)
	}

	function getTotalAmount(data = {}) {
		if (data.net_total_amount !== undefined) return toNumber(data.net_total_amount)

		return toNumber(data.total_amount) - toNumber(data.total_returned_amount)
	}

	return (
		<>
			<div className="page-header d-between mb-2">
				<h4 className="vertical-center">
					{t('cheques')} [{data?.total}]
				</h4>

				<Link to="/cashbox/create" className="btn btn-primary">
					{t('create')}
				</Link>
			</div>

			<div className="card">
				<div className="card-body">

					<div className="d-flex justify-content-between mb-3">
						<div className="d-flex gap-2">
							<div>
								<FilterSearch
									filterData={filterData}
									setFilterData={setFilterData}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('cashier')}</label>
												<Select
													options={cashiers}
													value={cashiers.find(option => option.login === filterData?.cashier_login) || ''}
													// value={filterData.cashiers}
													onChange={(option) => setFilterData({ ...filterData, cashier_login: option?.login })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.login}
													isClearable
												// isMulti
												/>
											</div>

											<div className="form-group col-md-6">
												<label>{t('clients')}</label>
												<Select
													isClearable
													options={clients}
													value={clients.find(option => option.id === Number(filterData.client_id)) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'client_id': option?.id })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>

											<div className="form-group col-md-6">
												<label>{t('payment')}</label>
												<Select
													isClearable
													options={reduxCashbox?.paymentTypes}
													value={reduxCashbox?.paymentTypes?.find(option => option.id === Number(filterData.payment_type_id)) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'payment_type_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('status')}</label>
												<Select
													isClearable
													options={chequeStatuses}
													value={chequeStatuses.find(option => option.id === Number(filterData.status)) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'status': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>

											<div className="form-group col-md-6">
												<label>{t('cheque')} ID</label>
												<input type="text" className="form-control" value={filterData.id}
													onChange={(e) => setFilterData({ ...filterData, 'id': e.target.value })} />
											</div>
											<div className="form-group col-md-6">
												<label>{t('shift')} ID</label>
												<input type="text" className="form-control" value={filterData.shift_id}
													onChange={(e) => setFilterData({ ...filterData, 'shift_id': e.target.value })} />
											</div>
											<div className="form-group col-md-6">
												<label>{t('client')} {t('phone')}</label>
												<input type="text" className="form-control" value={filterData.client_phone}
													onChange={(e) => setFilterData({ ...filterData, 'client_phone': e.target.value })} />
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-4">
												<label>{t('period')}</label>
												<Select
													options={chequeDates}
													value={chequeDates.find(option => option.id === filterData.chequeDates) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'chequeDates': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>

											<div className="form-group col-md-4">
												<label className="invisible">{t('period')}</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.start_date ? new Date(filterData.start_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'start_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
											<div className="form-group col-md-4">
												<label className="invisible">.</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.end_date ? new Date(filterData.end_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'end_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary"
														onClick={() => setDropdownIsOpen(false)}>
														{t('cancel')}
													</button>
													<button className="btn btn-primary"
														onClick={() => searchWithFilter()}>
														{t('apply')}
													</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
						<div className="vertical-center">
							<h4 className="text-end">
								<b>{t('amount')}</b>: {formatMoney(getTotalAmount(data))}
							</h4>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(filterData.start_date || filterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{filterData.start_date &&
											<span>{formatDate(filterData.start_date)}</span>
										}
										{(filterData.start_date && filterData.end_date) &&
											<span>|</span>
										}
										{filterData.end_date &&
											<span>{formatDate(filterData.end_date)}</span>
										}
									</span>
								}
								{filterData.status &&
									<span className="me-2">
										<b>{t('status')}: </b>
										{findKeyFromArrayByValue(statuses, 'id', filterData.status, 'name')}
									</span>
								}
								{filterData.cheque_type &&
									<span className="me-2">
										<b>{t('cheque_type')}: </b>
										{findKeyFromArrayByValue(chequeTypes, 'id', filterData.cheque_type, 'name')}
									</span>
								}
								{filterData.cashier_login &&
									<span className="me-2">
										<b>{t('cashier')}: </b>
										{findKeyFromArrayByValue(cashiers, 'login', filterData.cashier_login, 'first_name')}
									</span>
								}
								{filterData.id &&
									<span className="me-2">
										<b>ID: </b> {filterData.id}
									</span>
								}
								{filterData.shift_id &&
									<span className="me-2">
										<b>{t('shift')} ID: </b> {filterData.shift_id}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase"
									onClick={() => resetFilter()}>
									{t('reset')}
								</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '5%' }}>{t('cashier')}</th>
									<th style={{ 'width': '5%' }}>{t('courier')}</th>
									<th style={{ 'width': '5%' }} className="td-ellipsis">{t('shift')} №</th>
									<th style={{ 'width': '10%' }}>{t('client')}</th>
									<th style={{ 'minWidth': '120px' }} className="text-center">{t('phone')}</th>
									<th style={{ 'minWidth': '65px' }} className="text-center">{t('type')}</th>
									<th style={{ 'width': '7%' }} className="text-center">{t('status')}</th>
									<th style={{ 'width': '10%' }} className="text-center">{t('groups')}</th>
									<th style={{ 'minWidth': '130px' }} className="text-center">{t('open_date')}</th>
									<th style={{ 'minWidth': '130px' }} className="text-center">{t('close_date')}</th>
									<th style={{ 'width': '5%' }} className="td-ellipsis">{t('cheque')} №</th>
									<th style={{ 'width': '7%' }} className="text-end td-ellipsis">{t('paid')}</th>
									<th style={{ 'width': '7%' }} className="text-end td-ellipsis">{t('not_paid')}</th>
									<th style={{ 'width': '7%' }} className="text-end">{t('amount')}</th>
									<th style={{ 'minWidth': '33px' }} className="text-center"></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<Fragment key={index}>
										<tr className={`cursor ${item.showSidebar ? 'table-tr-active' : ''}`} onClick={() => redirect(item, index)}>
											<td className="text-center" title={item.id}>
												{item.row_number}
											</td>
											<td className="td-ellipsis">
												<CustomTooltip text={item.cashier_name}>
													{item.cashier_name}
												</CustomTooltip>
											</td>
											<td className="td-ellipsis" >
												<CustomTooltip text={item.courier_name}>
													{item.courier_name}
												</CustomTooltip>
											</td>
											<td>
												<CustomTooltip text={item.shift_id}>
													{item.shift_id}
												</CustomTooltip>
											</td>
											<td className="td-ellipsis">
												<CustomTooltip text={item.client_name}>
													{item.client_name}
												</CustomTooltip>
											</td>
											<td className="text-center">
												<CustomTooltip text={regexPhoneNumber(item.client_phone)}>
													{regexPhoneNumber(item.client_phone)}
												</CustomTooltip>
											</td>
											<td className="text-center td-ellipsis">
												{item.client_type_name}
											</td>
											<td className={`text-center ${returnClassStatus(item.status)}`}>
												{findKeyFromArrayByValue(chequeStatuses, 'id', item.status, 'name')}
											</td>
											<td className="text-center">
												<div className="d-flex justify-content-center gap-2">
													{item.groups
														.sort((a, b) => {
															const preferredOrder = [4, 3, 5, 1];
															const indexA = preferredOrder.indexOf(a.product_type_id);
															const indexB = preferredOrder.indexOf(b.product_type_id);
															return indexA - indexB;
														})
														.map((item2, index2) => (
															productImages.find(type => type.id === item2.product_type_id)?.id &&
															<OverlayTrigger
																key={index2}
																// delay={{ show: 250, hide: 250 }}
																overlay={(props) => renderTooltip(props, item2)}
															>
																<div>
																	{item2.product_type_id === 4 && <ProductType4 fill={item2.color} />}
																	{item2.product_type_id === 3 && <ProductType3 fill={item2.color} />}
																	{item2.product_type_id === 5 && <ProductType5 fill={item2.color} />}
																	{item2.product_type_id === 1 && <ProductType1 fill={item2.color} />}
																</div>
																{/* {productImages.find(type => type.id === item2.product_type_id)?.image} */}
																{/* <img src={productImages.find(type => type.id === item2.product_type_id)?.image} alt="" /> */}
															</OverlayTrigger>
														))
													}
												</div>
											</td>
											<td className={`text-center ${getChequeDebtAmount(item) <= 0 ? '' : 'bg-danger text-white'}`}>
												{formatDate(item.cheque_opened_at, 'dd.MM.yyyy HH:mm')}
											</td>
											<td className="text-center">
												{formatDate(item.cheque_closed_at, 'dd.MM.yyyy HH:mm')}
											</td>
											<td>
												<CustomTooltip text={item.id}>
													{item.id}
												</CustomTooltip>
											</td>
											<td className={`text-end text-nowrap`}>
												{formatMoney(getChequePaidAmount(item))}
											</td>
											<td className={`text-end text-nowrap`}>
												{formatMoney(getChequeDebtAmount(item))}
											</td>
											<td className={`text-end text-nowrap`}>
												{formatMoney(getChequeTotalAmount(item))}
											</td>
											<td className="py-0" style={{ verticalAlign: 'middle' }}>
												<div className="d-flex justify-content-end gap-1">

													<div className="table-dropdown-item " onClick={(e) => e.stopPropagation() + toggleRightbar(true, item, index)}>
														<OverlayTrigger overlay={(props) => renderTooltip(props, t('preview'))}>
															<i className="uil-eye"></i>
														</OverlayTrigger>
													</div>
													<div className="table-dropdown-item " onClick={(e) => e.stopPropagation() + printCheque(item)}>
														<OverlayTrigger overlay={(props) => renderTooltip(props, t('print'))}>
															<i className="uil-print"></i>
														</OverlayTrigger>

													</div>
													<div className="table-dropdown-item " onClick={(e) => e.stopPropagation() + printCheque(item, true)}>
														<OverlayTrigger overlay={(props) => renderTooltip(props, `${t('print')} A4`)}>
															<i className="uil-print"></i>
														</OverlayTrigger>
													</div>

													<div className="table-dropdown-item " onClick={(e) => e.stopPropagation() + sendTelegramCheque(item)}>
														<OverlayTrigger overlay={(props) => renderTooltip(props, t('send_telegram'))}>
															<i className="uil-telegram-alt"></i>
														</OverlayTrigger>
													</div>

													{(item.status === 3 && checkPermission('cashbox.return_cheque')) &&
														<div className="table-dropdown-item " onClick={(e) => e.stopPropagation() + toggleReturnModal(true, item, index)}>
															<OverlayTrigger overlay={(props) => renderTooltip(props, t('return'))}>
																<i className="uil-backward"></i>
															</OverlayTrigger>
														</div>
													}

													{item.status > 0 &&
														<>

															{checkPermission('cashbox.delete_cheque') &&
																<div className="table-dropdown-item " onClick={(e) => e.stopPropagation() + toggleModalDelete(true, item)}>
																	<OverlayTrigger overlay={(props) => renderTooltip(props, t('delete'))}>
																		<i className="uil-times-circle"></i>
																	</OverlayTrigger>
																</div>
															}

															{item.status !== 3 &&
																chequeStatuses.map((item2, index2) => (
																	(item2.id !== item.status) && item2.id > 0 &&
																	<div key={index2} onClick={(e) => e.stopPropagation() + changeChequeStatus(item, item2.id)} className={`table-dropdown-item  ga`}>
																		<OverlayTrigger overlay={(props) => renderTooltip(props, item2.name)}>
																			<i className={`${getStatusIcon(item2.id)}`}></i>
																		</OverlayTrigger>
																	</div>
																))
															}
														</>
													}
												</div>
											</td>
											{/* <td>
												<div className="table-dropdown">
													<Dropdown id={`dropdown-${index}`}>
														<Dropdown.Toggle variant="outline-primary">
															<i className="uil uil-ellipsis-v"></i>
														</Dropdown.Toggle>

														<Dropdown.Menu>
															<div className="table-dropdown-item" onClick={() => toggleRightbar(true, item, index)}>
																<i className="uil-eye"></i>
																{t('preview')}
															</div>
															<div className="table-dropdown-item" onClick={() => printCheque(item)}>
																<i className="uil-print"></i>
																{t('print')}
															</div>

															<div className="table-dropdown-item" onClick={() => printCheque(item, true)}>
																<i className="uil-print"></i>
																{t('print')} A4
															</div>

															{item.status !== 3 &&
																chequeStatuses.map((item2, index2) => (
																	item2.id !== item.status &&
																	<div key={index2} onClick={() => changeChequeStatus(item, item2.id)} className="table-dropdown-item">
																		{item2.name}
																	</div>
																))
															}
														</Dropdown.Menu>
													</Dropdown>
												</div>
											</td> */}
										</tr>
										{/* <tr key={index}>
											<td colSpan="12" className="py-0" style={{ verticalAlign: 'middle' }}>
												<div className="d-between">
													<div className="d-flex gap-2">
														{item.groups.map((item2, index2) => (
															<div className="px-2" key={index2}>
																{item2.name}:
																{item2.total_count}
															</div>
														))
														}
													</div>

													<div className="d-flex justify-content-end gap-3">
														<div className="table-dropdown-item" onClick={() => toggleRightbar(true, item, index)}>
															<b>
																<i className="uil-eye me-1"></i>
																{t('preview')}
															</b>
														</div>
														<div className="table-dropdown-item" onClick={() => printCheque(item)}>
															<b>
																<i className="uil-print me-1"></i>
																{t('print')}
															</b>
														</div>
														<div className="table-dropdown-item" onClick={() => printCheque(item, true)}>
															<b>
																<i className="uil-print me-1"></i>
																{t('print')} A4
															</b>
														</div>
														<div className="table-dropdown-item" onClick={() => sendTelegramCheque(item)}>
															<b>
																<i className="uil-telegram-alt me-1"></i>
																{t('send_telegram')}
															</b>
														</div>
														{item.status !== 3 &&
															chequeStatuses.map((item2, index2) => (
																item2.id !== item.status &&
																<div key={index2} onClick={() => changeChequeStatus(item, item2.id)} className={`table-dropdown-item gap-0`}>
																	<i className={`${getStatusIcon(item2.id)} me-1`}></i>
																	{item2.name}
																</div>
															))
														}
													</div>
												</div>
											</td>
										</tr> */}
									</Fragment>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}
				</div>
			</div>

			{/* MODAL ADDITIONAL INFO */}
			<Modal
				show={showModal} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => setShowModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('additional_info')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('guests')}</span>
						<span>{data.total_people_number}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('number_of_checks')}</span>
						<span>{data.total}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('number_of_checks')} [ {t('hall')} ]</span>
						<span>{data.total_hall}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('number_of_checks')} [ {t('takeaway')} ]</span>
						<span>{data.total_takeaway}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('number_of_checks')} [ {t('delivery')} ]</span>
						<span>{data.total_delivery}</span>
					</div>
					<div className="d-flex justify-content-between mb-1 ms-3">
						<span>{t('number_of_checks')} [ {t('manager')} ]</span>
						<span>{data.total_delivery_manager}</span>
					</div>
					<div className="d-flex justify-content-between mb-1 ms-3">
						<span>{t('number_of_checks')} [ {t('telegram')} ]</span>
						<span>{data.total_delivery_telegram}</span>
					</div>
					<div className="d-flex justify-content-between mb-1 ms-3">
						<span>{t('number_of_checks')} [ {t('call_center')} ]</span>
						<span>{data.total_delivery_call_center}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('number_of_checks')} [ {t('deleted')} ]</span>
						<span>{data.total_deleted}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('number_of_checks')} [ {t('discount')} ]</span>
						<span>{data.total_discount}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('number_of_checks')} [ {t('agents')} ]</span>
						<span>{data.total_agents}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('number_of_checks')} [ {t('debt')} ]</span>
						<span>{data.total_debtor}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('number_of_checks')} [ {t('no_profit')} ]</span>
						<span>{data.total_no_profit}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('number_of_checks')} [ {t('no_service_percentage')} ]</span>
						<span>{data.total_no_service_percentage}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('discount')}</span>
						<span>{formatMoney(data.total_discount)}</span>
					</div>
					<div className="d-flex justify-content-between mb-1">
						<span>{t('delivery')}</span>
						<span>{formatMoney(data.total_delivery_price)}</span>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL ADDITIONAL INFO */}

			<DeleteModal
				showNote={true}
				modalDelete={modalDelete}
				setModalDelete={toggleModalDelete}
				setNote={setModalDelete}
				deleteItem={deleteItem}>
			</DeleteModal>

			<Rightbar
				showRightBar={showRightBar}
				setShowRightBar={setShowRightBar}
				toggleModalDelete={toggleRightbar}
				selectedItem={selectedItem}>
			</Rightbar>

			<Cheque data={printData} printChequeRef={printChequeRef} />

			<ReturnModal
				showModal={returnModal}
				setShowModal={() => toggleReturnModal(false)}
				onSuccess={() => getData()}
			/>
		</>
	)
}

export default Index
